import api from "../../api"
import { getSession } from "../../auth"

// Fire-and-forget report to kwikapi's cortex_answer_action endpoint (see
// spec_curadoria.md) - kwikapi just relays this into the ticket's CDR via
// IvCdrSender.cortex_message(). Failures are logged only: this must never
// block or surface to the operator, and never affect any of the existing
// instant-aio-api calls it rides alongside.
const reportCuradoria = ({ uniqueid, question, answer, sources, action }) => {
    if (!uniqueid || !question || !answer) return

    const agentId = getSession()?.profile?.agent?.id
    if (!agentId) return

    api.post(`/api/IV/agents/${agentId}/cortex_answer_action/`, {
        uniqueid,
        question,
        answer,
        sources: sources || [],
        action: action || null,
    }).catch((err) => {
        console.error('[CortexAssistant] Failed to report curadoria event', err)
    })
}

export default reportCuradoria
